import Vue from 'vue';
import Vuex from 'vuex';
import { userInfoState, userInfoMutations, userInfoActions } from './user';
import { settingsState, settingsMutations, settingsActions } from './settings';
import { adTempState, adTempMutations, adTempActions } from './create-temp';
import getEnv from '@/utils/get-env';
import getMixinInfo from '@/utils/get-mixin-app';
import {
  noticeTempState,
  noticeTempMutations,
  noticeTempActions,
} from './notice-temp';
import {
  orderTempState,
  orderTempMutations,
  orderTempActions,
} from './order-temp';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    env: Object.freeze(Object.assign(getEnv(), getMixinInfo())),
    hasCloseHomeNotice: false,
    navLang: '',
    navLangMain: '',
    serviceUuid:
      (window.__TIGA_CONFIG__ &&
        window.__TIGA_CONFIG__.serviceUuid) ||
      '',
    ...userInfoState,
    ...settingsState,
    ...adTempState,
    ...noticeTempState,
    ...orderTempState,
  },
  mutations: {
    ...userInfoMutations,
    ...settingsMutations,
    ...adTempMutations,
    ...noticeTempMutations,
    ...orderTempMutations,
    setNavLang(state, obj) {
      if (obj.lang) {
        state.navLang = obj.lang;
      }
      if (obj.langMain) {
        state.navLangMain = obj.langMain;
      }
    },
    setTigaHome(state, obj){
      if(obj.hasCloseHomeNotice){
        state.hasCloseHomeNotice = obj.hasCloseHomeNotice;
      }
      if(obj.tigaNotice){
        state.tigaNotice = obj.tigaNotice;
      }
      if(obj.tigaRates){
        state.tigaRates = obj.tigaRates;
      }
    },
  },
  actions: {
    ...userInfoActions,
    ...settingsActions,
    ...adTempActions,
    ...noticeTempActions,
    ...orderTempActions,
  },
});